export type DeviceClass = 'phone' | 'tablet' | 'desktop';

/**
 * Classify the device by hardware signals instead of the user agent —
 * iPadOS Safari sends a macOS desktop user agent by default, so
 * UA-based classifiers (PostHog's `$device_type`) file iPads under Desktop.
 *
 * Thresholds validated against 30 days of production pageviews:
 * real phones' shorter screen side is 320–440px; every iPad model fits
 * shorter ≤ 1024 × longer ≤ 1400; the long-side cap excludes
 * touchscreen Windows laptops (1920×1080 touch).
 */
export function classifyDevice(screenWidth: number, screenHeight: number, touch: boolean): DeviceClass {
    const shortSide = Math.min(screenWidth, screenHeight);
    const longSide = Math.max(screenWidth, screenHeight);
    if (shortSide <= 480) {
        return 'phone';
    }
    if (touch && shortSide <= 1024 && longSide <= 1400) {
        return 'tablet';
    }
    return 'desktop';
}
